export const styles = `
* {
  font-size: 8px;
}


.l-grey-bg {
  background-color: lightgray;
}
.grey-bg {
  background-color: gray;
}

.center-content {
  text-align: center;
}
.padding-4 {
  padding: 4px;
}
.padding-2 {
  padding: 2px;
}
.AASQR-table,
.AASQR-table th,
.AASQR-table td {
  border: 1.2px solid black;
  border-collapse: collapse;
}
.AASQR-table td {
  padding: 3px;
}
.AASQR-table table,
.AASQR-table table th,
.AASQR-table table td {
  border: none;
  border-collapse: collapse;
}
.bold {
  font-weight: 700;
}
.border-top-0 {
  border-top: 0px;
}
.white-text {
  color: white;
}
.AASQR-table .bold-extra {
  font-weight: 900 !important;
}
.source,.Deliverable{
  padding:3px 48px;
}
.Ananya_Sound_Rescans{
  padding: 5px 184px;
}
.Digitization_QC_Report
{
  padding-right:50px;
  text-align: center; 
}

.baby-blue-color{
  background-color: #89CFF0; /* Use background-color for the background */
  color: black;
}
.lightYellow-color{
  background-color: #ffffcc;
}
.red-color{
  color: red;
}
.lightRed-color{
  background-color: #eeeeee;
}
.WhiteSmoke-color{
  background-color: #cfe7f5;
}
.cyan-blue-color{
  background-color: #99ccff;
}
 .center-right {
   text-align: right;
  }
`;
